import { FundingPolicyType } from '@shared';

export const POLICY_PRODUCT_NAME_MAPPING = {
  'Asset Care': FundingPolicyType.assetCare,
  'CareMatters® II': FundingPolicyType.careMattersTwo,
  'CareMatters® Together': FundingPolicyType.jointCareMatters,
  'CareScout Care Assurance': FundingPolicyType.careScoutCareAssurance,
  'CareScout': FundingPolicyType.careScoutCareAssurance, // Add shorter product name
  'MoneyGuard Fixed Advantage® (2025)': FundingPolicyType.moneyGuardFixedAdvantage,
  'SecureCare III': FundingPolicyType.secureCareThree,
} as const;

export const getPolicyTypeFromProductName = (
  productName: string,
  isJointPolicy: boolean = false,
): FundingPolicyType | undefined => {
  if (productName === 'Asset Care') {
    return isJointPolicy ? FundingPolicyType.jointAssetCare : FundingPolicyType.assetCare;
  }
  return POLICY_PRODUCT_NAME_MAPPING[productName as keyof typeof POLICY_PRODUCT_NAME_MAPPING];
};

export const findPartnerPolicyFundingSourceId = (
  partnerClient: Client,
  policyToMatch: {
    insuranceQuoteId?: string;
  },
): string | null => {
  if (!partnerClient.multipleFundingSources?.ltcPolicy) {
    return null;
  }

  if (policyToMatch.insuranceQuoteId) {
    for (const [partnerFundingId, partnerPolicy] of Object.entries(
      partnerClient.multipleFundingSources.ltcPolicy,
    )) {
      if (partnerPolicy.insuranceQuoteId === policyToMatch.insuranceQuoteId) {
        return partnerFundingId;
      }
    }
  }

  return null;
};

export const deleteJointPolicyFromBothClients = (
  dispatch: any,
  currentClient: Client,
  fundingSourceId: string,
  putMultipleFundingSourceForClientByClientIdRequest: any,
) => {
  const policyBeingDeleted = currentClient.multipleFundingSources?.ltcPolicy[fundingSourceId];

  dispatch(
    putMultipleFundingSourceForClientByClientIdRequest({
      clientId: currentClient.clientId,
      fundingSourceType: 'ltcPolicy',
      fundingSourceData: null,
      fundingSourceId,
    }),
  );

  if (
    policyBeingDeleted &&
    currentClient.mutableClientPartner &&
    policyBeingDeleted.insuranceQuoteId
  ) {
    const partnerFundingSourceId = findPartnerPolicyFundingSourceId(
      currentClient.mutableClientPartner,
      {
        insuranceQuoteId: policyBeingDeleted.insuranceQuoteId,
      },
    );

    if (partnerFundingSourceId) {
      dispatch(
        putMultipleFundingSourceForClientByClientIdRequest({
          clientId: currentClient.mutableClientPartner.clientId,
          fundingSourceType: 'ltcPolicy',
          fundingSourceData: null,
          fundingSourceId: partnerFundingSourceId,
        }),
      );
    }
  }
};
